import Vue from "vue";

import UUID from "vue-uuid";
Vue.use(UUID);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "@/utils/fontawesome.js";
Vue.component("FontAwesomeIcon", FontAwesomeIcon);

require
  .context("@/DS/", false, /\.vue$/)
  .keys()
  .forEach(fileName => {
    const clearedFileName = fileName.split(".")[1].split("/")[1];

    import(`@/DS/${clearedFileName}`).then(comp => {
      Vue.component(clearedFileName, comp.default);
    });
  });
